module.exports = __webpack_public_path__ + "static/media/3DPPA4.8d78f823.jpg";